import { CHURN_ZERO_EVENTS as cz } from './constants'

export const setContact = (orgId, userEmail) => {
  if (process.env.REACT_APP_ENABLE_CHURNZERO_EVENTS !== 'true') {
    return
  }

  window.ChurnZero.push(['setContact', orgId, userEmail])
}

/**
 * wraps around ChurnZero.trackEvent method
 * @param e - { eventName, description, quantity, customFields, errorMsg }
 */
export const trackEvent = e => {
  if (process.env.REACT_APP_ENABLE_CHURNZERO_EVENTS !== 'true') {
    return
  }
  const eventName = typeof e === 'string' ? e : e.eventName
  const { description, quantity, customFields, errorMsg } = e
  const customFieldsToSend = {
    IS_VITE_BUILD: process.env.BUILD_VITE,
    ...customFields,
  }

  const event = [
    'trackEvent',
    `${eventName} ${errorMsg ? 'Error' : 'Success'}`,
    errorMsg || description,
    quantity,
    customFieldsToSend,
  ]
  window.ChurnZero.push(event)
}

export const stopCZTracking = () => {
  trackEvent(cz.LOG_OUT)
  window.ChurnZero.push(['stop'])
}
